import styled from "@emotion/styled";

import { fontRoboto, fontSourceSerif4, theme } from "shared/lib/styles";

import {
  clickableFrameLinkStyles,
  clickableFrameStyles,
} from "scmp-app/components/content/content-item-render/clickable-frame/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  ${clickableFrameLinkStyles}
  display: flex;
  flex: 1;
  flex-direction: column;

  color: #000000;
`;

export const Container = styled.div`
  ${clickableFrameStyles(StyledEntityLink)}
  display: flex;
  flex-direction: column;

  block-size: 100%;
`;

export const Content = styled.div``;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontSourceSerif4};
  line-height: 130%;
  letter-spacing: -0.32px;

  ${theme.breakpoints.up("tablet")} {
    font-weight: 500;
  }
`;

export const SponsorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  inline-size: fit-content;
  margin-block-start: 12px;
`;

export const SponsorType = styled.div`
  padding-block-start: 8px;

  border-block-start: 1px solid #dfdfdf;

  color: #727272;
  font-weight: 400;
  font-size: 10px;
  font-family: ${fontRoboto};
`;

export const SponsorName = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
`;
